import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { PermissionService } from "src/app/services/permission.service";

@Directive({
  selector: '[appPermission]',
  standalone: true
})
export class PermissionDirective {
  @Input('appPermission') permission!: string | string[];

  constructor(
    private tpl: TemplateRef<any>,
    private vcr: ViewContainerRef,
    private permissionSvc: PermissionService
  ) { }

  ngOnInit() {
    const ok = Array.isArray(this.permission)
      ? this.permissionSvc.hasAny(this.permission)
      : this.permissionSvc.has(this.permission);

    if (ok) {
      this.vcr.createEmbeddedView(this.tpl);
    } else {
      this.vcr.clear();
    }
  }
}
